import { render, staticRenderFns } from "./errorlayout.vue?vue&type=template&id=c45066f6&"
import script from "./errorlayout.vue?vue&type=script&lang=js&"
export * from "./errorlayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports